import { useNavigate } from "react-router-dom";
import { PropsView } from "../Models/faq";

const infos = [
  {
    title: "O que é Freeflow?",
    text: "O Free Flow é um sistema de pedágio eletrônico que permite a passagem de veículos sem a necessidade de reduação de velocidade e/ou parada do veículo.  A identificação é feita automaticamente por antenas e câmeras, e o valor é associado à TAG ou a placa do veículo."
  },
  {
    title: "O que é o Pedágio Eletrônico Sem Parar?",
    text: "O Pedágio Eletrônico Sem Parar é uma plataforma onde você pode consultar e pagar suas passagens, via  site,  em rodovias cuja as concessionarias fizeram adesão, atualmente é possível encontrar as passagens das seguintes concessionárias:\n\nConcessionária SP Serra (Rodoanel Norte) - Grupo Via Appia"
  },
  {
    title: "Quais são os benefícios do Free Flow em pedágios?",
    text: "O Free Flow torna a viagem mais rápida e segura, eliminando paradas para pagamento."
  },
  {
    title: "Como faço para pagar as tarifas de Free Flow?",
    text: "– Se você tem uma tag instalada, a cobrança é feita automaticamente pela sua operadora de tag e você não precisa tomar nenhuma ação.\n\n– Se não tem tag, é necessário consultar suas passagens no site do Pedágio Eletrônico Sem Parar ou no portal da concessionária e efetuar o pagamento."
  },
  {
    title: "Como funciona o Free Flow?",
    text: "O sistema usa tecnologias de antenas que permitem identificar as TAGs (exemplo: Sem Parar) e câmeras de leitura de placas, além de cameras que permitem identificar o tamanho e largura dos veículos, bem como classificar a quantidade de eixos. Os sensores identificam o veículo na pista e realizam a cobrança automaticamente, sem necessidade de parada."
  },
  {
    title: "Onde o Free Flow está disponível?",
    text: "O Free Flow está sendo implementado em diversas rodovias no Brasil e no mundo, especialmente em locais com grande fluxo de veículos para melhorar o trânsito."
  },
  {
    title: "Como funciona o Free Flow para quem tem tag?",
    text: "Se você tem uma tag instalada, sua passagem pelo pórtico do Free Flow é registrada automaticamente. Além da praticidade, o uso da tag garante desconto na tarifa, você pode consultar diretamento nos portais das conessionárias para saber quais os descontos estão disponíveis."
  },
  {
    title: "Quais as concessionárias / rodovias que posso fazer o pagamento com o Pedágio Eletrônico Sem Parar?",
    text: "No momento temos parceria com a(s) concessionária(s) abaixo:\n\nConcessionária SP Serra (Rodoanel Norte) - Grupo Via Appia"
  },
  {
    title: "Passei por um pórtico que não está na relação. O que fazer?",
    text: "Verifique a passagem no site da concessionária responsável e siga as instruções para pagamento."
  },
  {
    title: "Em quanto tempo aparece a cobrança de passagem no freeflow (para clientes sem tag)?",
    text: "A tarifa pode levar até 48 horas para aparecer no sistema. Se não encontrar sua passagem, tente novamente mais tarde. O pagamento deve ser feito em até 30 dias após a passagem no pórtico."
  },
  {
    title: "Qual o prazo para pagamento das passagens de Free Flow?",
    text: "Você tem até 30 dias para pagar. Após esse prazo, podem ser aplicados juros, multas e registro de inadimplência. Além disso, o motorista está sujeito a uma multa de R$ 195,23 e 5 pontos na CNH por evasão de pedágio."
  },
  {
    title: "O que é evasão?",
    text: "Evasão de pedágio nada mais é do que o ato de transpor um pedágio ou pórtico Free Flow sem efetuar o pagamento.\n\nA evasão é caracterizada pela ação de um veículo que passa pelo pedágio sem o registro do pagamento da tarifa, para regularização, esta passagem deverá ser quitada."
  },
  {
    title: "Como a multa é registrada?",
    text: "No sistema Free Flow, as passagens são registradas automaticamente por sensores e câmeras de leitura de placas. Se o pagamento não for identificado dentro de um tempo determinado a multa será gerada e o proprietário do veículo será notificado."
  },
  {
    title: "Como eu recorro a passagens no freeflow que eu não reconheço?",
    text: "Primeiramente, verifique as informações como data, hora, local e valor;\n\nAcesse a área \"Fale Conosco\" no site da concessionária para contestar a cobrança."
  },
  {
    title: "Dúvidas sobre a multa do Free Flow?",
    text: "O não pagamento da tarifa em até 30 dias corridos da passagem está sujeito a multa de trânsito no valor de R$ 195,23 e 5 pontos na CNH (Artigo 209 do Código de Trânsito Brasileiro), além de encargos. A data da infração é referente ao vencimento do pagamento da passagem, ou seja, o trigésimo primeiro dia. No rodapé da notificação da multa encontram-se a data e hora da passagem pelo pórtico de cobrança. Vale lembrar que a multa não desobriga o pagamento da tarifa."
  },
  {
    title: "Qual é o prazo para pagar ou contestar a multa?",
    text: "Os prazos para pagamento e contestação da multa estão indicados na notificação que você recebeu e a contestação é feita diretamente ao orgão de transito que emitiu o domcumento. Lembre-se de que pagar a multa não isenta o pagamento do pedágio."
  },
  {
    title: "Existe desconto para usuários frequentes?",
    text: "Sim. Algumas rodovias oferecem desconto para usuários com tag. Consulte o site da concessionária para mais informações."
  },
  {
    title: "Como Consultar meu recibo de pagamento?",
    text: "No menu do Pedágio Eletrônico Sem Parar, acesse \"Meus Recibos\", valide o acesso e baixe o recibo desejado."
  },
  {
    title: "Consultei o site e encontrei uma passagem que não reconheço. Posso contestar a passagem do Free Flow?",
    text: "Sim! Se você acha que a passagem foi gerada de forma equivocada, você pode contestar.\n\nPara recorrer, você pode acessar o site da concessionária responsável, onde encontrará o processo de contestação. Será necessário fornecer dados do veículo e informações sobre o erro."
  },
  {
    title: "Posso cadastrar mais de um veículo na mesma conta?",
    text: "Sim, basta acessar \"Meu Perfil\" e adicionar o novo veículo."
  },
  {
    title: "Como altero meus dados cadastrais?",
    text: "A alteração de dados cadastrais pode ser feita através do site do Pedágio Eletrônico Sem Parar, após o login, selecione \"perfil\" e em seguinda \"meus dados\"."
  },
  {
    title: "O que acontece se o pagamento não for realizado?",
    text: "De acordo com o artigo 209-A do Código de Trânsito Brasileiro (CTB), não pagar a tarifa de pedágio é uma infração grave. Isso pode resultar em uma multa de R$ 195,23 e 5 pontos na CNH."
  },
  {
    title: "O que acontece se minha tag não tiver saldo suficiente?",
    text: "Entre em contato com a operadora da tag para regularizar a situação. Caso não pague, estará sujeito a multa por evasão de pedágio."
  },
  {
    title: "E se minha tag não for reconhecida no pedágio?",
    text: "Caso a passagem não seja cobrada automaticamente, você poderá pagar manualmente dentro de um prazo no site do Pedágio Eletrônico Sem Parar. Se precisar de ajuda, entre em contato com a sua operadora de tag para mais informações."
  },
  {
    title: "O que acontece se meu veículo não for identificado corretamente?",
    text: "Se o sistema não conseguir identificar seu veículo automaticamente, você pode ser cobrado com base na sua placa por meio de fiscalização por câmeras ou receber uma notificação para regularizar a cobrança. É importante garantir que sua tag esteja funcionando corretamente e esteja bem posicionada no veículo para evitar problemas."
  },
  {
    title: "Quais são os métodos de pagamento disponíveis para os veículos que não possuem tag?",
    text: "Você pode pagar em até 30 dias após a passagem, via Pix, cartão de crédito no site do Pedágio Eletrônico Sem Parar."
  },
  {
    title: "Quais os contatos das concessionárias que atuam no freeflow?",
    text: "No momento temos parceria com a(s) concessionária(s) abaixo, caso necessite contatar, ela(s) para tirar alguma dúvida com relação as passagens abaixo está a lista de concessionarias e telefones de atendimento:\n\nConcessionária SP Serra (Rodoanel Norte) - Grupo Via Appia -> (11) 4327-3398"
  },
  {
    title: "As câmeras dos pórticos multam por excesso de velocidade?",
    text: "As câmeras identificam os veículos para cobrança da tarifa. Porém, algumas rodovias também possuem radares para fiscalização de velocidade."
  },
  {
    title: "O Free Flow cobra por quilômetro percorrido?",
    text: "O modelo de cobrança do Free Flow  varia conforme a rodovia e a regulamentação vigente. Em algumas rodovias, como a Via Dutra na Região Metropolitana de São Paulo, a tarifa é proporcional à distância percorrida, ou seja, por quilômetro rodado. Já em outras rodovias, a cobrança é feita por tarifa fixa ao passar pelos pórticos, independentemente da distância percorrida"
  },
  {
    title: "Como vai funcionar a bonificação a tarifa para veículos isentos no modelo Free Flow?",
    text: "Cada concessionária tem um processo específico para registrar veículos isentos. Consulte a concessionária responsável para saber como fazer o cadastro.\n\nA isenção é concedida para veículos que atendem aos critérios definidos pelo orgão regulador (ex.: ARTESP, ANTT)"
  }
];

export default function useFaqPage(): PropsView {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const goToContact = () => navigate("/faq/contact");

  return {
    goBack,
    goToContact,
    infos,
  };
}
